<div class="report-attachments">
    <div class="files-grid">
        <button
            type="button"
            class="add-file-btn"
            [class.drag-over]="isDragOver"
            [class.disabled]="disabled || items.length >= maxFiles"
            [disabled]="disabled || items.length >= maxFiles"
            [attr.aria-label]="'components.report-problem-dialog.attachments.add' | translate"
            (click)="openFilePicker()"
        >
            <mat-icon *ngIf="!isDragOver">add</mat-icon>
            <ng-container *ngIf="isDragOver">
                <mat-icon class="upload-icon">upload</mat-icon>
                <span class="upload-label">{{ 'components.report-problem-dialog.attachments.drop' | translate }}</span>
            </ng-container>
        </button>

        <div class="add-file-text" *ngIf="!items.length">
            <button type="button" class="add-file-link" [disabled]="disabled" (click)="openFilePicker()">
                {{ 'components.report-problem-dialog.attachments.add' | translate }}
            </button>
            <span class="paste-hint">{{ 'components.report-problem-dialog.attachments.paste-hint' | translate }}</span>
        </div>

        <div class="file-container" *ngFor="let item of items">
            <button
                *ngIf="!disabled"
                type="button"
                class="delete-file-btn"
                [attr.aria-label]="'components.report-problem-dialog.attachments.remove' | translate: { name: item.file.name }"
                (click)="remove(item)"
            >
                <mat-icon>close</mat-icon>
            </button>
            <div class="file-preview" [class.document-icon]="item.isPdf" [class.file-uploading]="item.uploading">
                <img *ngIf="item.previewUrl" [src]="item.previewUrl" [alt]="item.file.name" />
                <img *ngIf="item.isPdf" src="assets/images/pdf-file.svg" alt="PDF" />
            </div>
            <div class="file-name" [title]="item.file.name">{{ item.file.name }}</div>
        </div>
    </div>

    <p class="paste-hint paste-hint--below" *ngIf="items.length && items.length < maxFiles">
        {{ 'components.report-problem-dialog.attachments.paste-hint' | translate }}
    </p>

    <ul class="rejections" aria-live="polite">
        <li *ngFor="let rejection of rejections">
            {{ 'components.report-problem-dialog.attachments.errors.' + rejection.reason | translate: { name: rejection.name, max: rejection.reason === 'count' ? maxFiles : maxFileSizeMB } }}
        </li>
    </ul>

    <input #fileInput type="file" multiple hidden accept="image/*,application/pdf" (change)="onFileSelected($event)" />
</div>
